import React, { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm, Controller } from "react-hook-form"
import { selectors as appSelectors } from '../features/app'
import { actionTypes, selectors } from '../features/customer'
import FieldText from '../components/FieldText'
import FieldCheckbox from '../components/FieldCheckbox'
import { selectors as dealerSelectors, actionTypes as dealerActionTypes } from '../features/dealer'
import { selectors as valuationSelectors } from '../features/valuation'
import { IOpeningHours } from '../features/dealer/types'
import { actionTypes as errorActionTypes } from '../features/error'
import { actionTypes as appActionTypes } from '../features/app'
import { selectors as vehicleSelectors } from '../features/vehicle'
import { selectors as qaSelectors } from '../features/qa'
import { AnalyticElement, AnalyticType, ApiResult, baseName } from '../types.d'
import { getDealerInfo, postVehicleLead, validateEmail, validatePhone } from '../api'
import { IError, IErrorButton } from '../features/error/types'
import { Routes, ILead } from '../types.d'
import _ from 'lodash'
import FieldSelect from '../components/FieldSelect'
import { IConditionAnswer } from '../features/qa/types'
import { EAppVersion } from '../features/app/types'
// import ErrorSummary from '../components/ErrorSummary'

interface ContactValues {
  handleAnalyticEvent: Function,
  handleContactSubmit: Function, 
  handleDealerLoaded: Function
}
const Contact: React.FC<ContactValues> = ({ handleAnalyticEvent, handleContactSubmit, handleDealerLoaded }) => {
  type FormData = {
    firstName: string,
    lastName: string,
    email: string,
    mobile: string,
    dealerBranch?: string,
    terms: boolean
  };

  const dispatch = useDispatch();
  const version = useSelector(appSelectors.getAppVersion);
  const disabled = useSelector(appSelectors.getAppIsLoading);
  const firstName = useSelector(selectors.getCustomerFirstName);
  const lastName = useSelector(selectors.getCustomerLastName);
  const email = useSelector(selectors.getCustomerEmail);
  const mobile = useSelector(selectors.getCustomerMobile);
  const terms = useSelector(selectors.getCustomerTerms);
  // const marketing = useSelector(selectors.getCustomerMarketing);
  const dealerId = useSelector(dealerSelectors.getDealerId);
  const stockDealerId = useSelector(dealerSelectors.getDealerStockId);
  const locationName = useSelector(dealerSelectors.getDealerLocationName);
  const privacyPolicy = useSelector(dealerSelectors.getDealerPrivacyPolicy);
  const offerDate = useSelector(appSelectors.getAppOfferDate);
  const rego = useSelector(vehicleSelectors.getVehicleRego);
  const auststate = useSelector(vehicleSelectors.getVehicleAustState);
  const kms = useSelector(vehicleSelectors.getVehicleKms);
  const vin = useSelector(vehicleSelectors.getVehicleVin);
  const year = useSelector(vehicleSelectors.getVehicleYear);
  const make = useSelector(vehicleSelectors.getVehicleMake);
  const family = useSelector(vehicleSelectors.getVehicleFamily);
  const badge = useSelector(vehicleSelectors.getVehicleBadge);
  const badge2nd = useSelector(vehicleSelectors.getVehicleBadge2nd);
  const vehicleSummary = useSelector(vehicleSelectors.getVehicleSummaryLine);
  const vehicleSpec = useSelector(vehicleSelectors.getVehicleSpecLine);
  const vehicleImage = useSelector(vehicleSelectors.getVehicleImage);
  const redbookCode = useSelector(vehicleSelectors.getVehicleRedbookCode);
  const rbid = useSelector(vehicleSelectors.getVehicleRbid);
  const makecode = useSelector(vehicleSelectors.getVehicleMakecode);

  const familycode = useSelector(vehicleSelectors.getVehicleFamilycode);
  const vehicletype = useSelector(vehicleSelectors.getVehicleType);
  const month = useSelector(vehicleSelectors.getVehicleMonth);
  const sequenceno = useSelector(vehicleSelectors.getVehicleSequenceno);
  const description = useSelector(vehicleSelectors.getVehicleDescriptionLine);
  const newvehicleflag = useSelector(vehicleSelectors.getVehicleNewvehicleflag);
  const importflag = useSelector(vehicleSelectors.getVehicleImportflag);
  const limitededition = useSelector(vehicleSelectors.getVehicleLimitededition);
  const series = useSelector(vehicleSelectors.getVehicleSeries);
  const bodystyle = useSelector(vehicleSelectors.getVehicleBodystyle);
  const drive = useSelector(vehicleSelectors.getVehicleDrive);
  const geartype = useSelector(vehicleSelectors.getVehicleGeartype);
  const gearlocation = useSelector(vehicleSelectors.getVehicleGearlocation);
  const gearnum = useSelector(vehicleSelectors.getVehicleGearnum);
  const doornum = useSelector(vehicleSelectors.getVehicleDoornum);
  const enginesize = useSelector(vehicleSelectors.getVehicleEnginesize);
  const enginedesc = useSelector(vehicleSelectors.getVehicleEnginedesc);
  const cylinders = useSelector(vehicleSelectors.getVehicleCylinders);
  const fueltype = useSelector(vehicleSelectors.getVehicleFueltype);
  const induction = useSelector(vehicleSelectors.getVehicleInduction);
  const cam = useSelector(vehicleSelectors.getVehicleCam);
  const enginetype = useSelector(vehicleSelectors.getVehicleEnginetype);
  const fuelcapacity = useSelector(vehicleSelectors.getVehicleFuelcapacity);
  const fueldelivery = useSelector(vehicleSelectors.getVehicleFueldelivery);
  const methoddelivery = useSelector(vehicleSelectors.getVehicleMethoddelivery);
  const gvm = useSelector(vehicleSelectors.getVehicleGvm);
  const wheelbase = useSelector(vehicleSelectors.getVehicleWheelbase);
  const height = useSelector(vehicleSelectors.getVehicleHeight);
  const length = useSelector(vehicleSelectors.getVehicleLength);
  const width = useSelector(vehicleSelectors.getVehicleWidth);
  const kerbweight = useSelector(vehicleSelectors.getVehicleKerbweight);
  const taremass = useSelector(vehicleSelectors.getVehicleTaremass);
  const power = useSelector(vehicleSelectors.getVehiclePower);
  const powerrpmto = useSelector(vehicleSelectors.getVehiclePowerrpmto);
  const torque = useSelector(vehicleSelectors.getVehicleTorque);
  const torquerpmfrom = useSelector(vehicleSelectors.getVehicleTorquerpmfrom);
  const torquerpmto = useSelector(vehicleSelectors.getVehicleTorquerpmto);
  const seatcapacity = useSelector(vehicleSelectors.getVehicleSeatcapacity);
  const avgkm = useSelector(vehicleSelectors.getVehicleAvgkm);
  const gdkm = useSelector(vehicleSelectors.getVehicleGdkm);
  const newprice = useSelector(vehicleSelectors.getVehicleNewprice);
  const isBestMatch = useSelector(vehicleSelectors.getVehicleIsBestMatch);
  const matchDebug = useSelector(vehicleSelectors.getVehicleMatchDebug);
  const conditions: Array<IConditionAnswer> = useSelector(qaSelectors.getQaConditionsArray);
  const valuation = useSelector(valuationSelectors.getValuationValuation);
  const answers = useSelector(qaSelectors.getQaAnswersArray);
  const interestedNext = useSelector(qaSelectors.getQaInterestedNext);
  const valuationResult = useSelector(valuationSelectors.getValuationResult);
  const colour = useSelector(qaSelectors.getQaColour);
  const termsUrl = useSelector(dealerSelectors.getDealerTerms);

  const { handleSubmit, control, setError, clearErrors, formState: { errors } } = useForm<FormData>();
  const [isInit, setIsInit] = useState(false);
  const [isEmailValidated, setIsEmailValidated] = useState(false);
  const [isPhoneValidated, setIsPhoneValidated] = useState(false);
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [isPhoneLoading, setIsPhoneLoading] = useState(false);
  const [lastEmail, setLastEmail] = useState('');
  const [lastPhone, setLastPhone] = useState('');
  const [branches, setBranches] = useState([{label: "Preferred Dealership ", value: ""}]);

  const isSubmitDisabled = !isEmailValidated || !isPhoneValidated;

  // const valuationResult2: any = _.cloneDeep(valuationResult);
 
  const getDealer = async () => {
    const traffic:ApiResult<any> = await getDealerInfo(dealerId);
    if (!traffic.errormessage && traffic.result){
      const d: Array<any> = traffic.result.DealerSites.length > 1 ? traffic.result.DealerSites.filter((d: any) => d.IsPrincipal) : traffic.result.DealerSites.length ? traffic.result.DealerSites : [];
      if (!d.length) return null;
      const ds = d[0];
      const phone = ds.Phone;
      const address = `${ds.Address} ${ds.Suburb} ${ds.State} ${ds.Postcode}`;
      const website = ds.Website;
      const terms = traffic.result.Terms;
      let openingHours: Array<IOpeningHours> = [];
      try {
        openingHours = JSON.parse(ds.SalesOperatingHours);
      }
      catch {
        console.log('error parsing opening hours.');
      }
      // setDealershipOptions
      const b = traffic.result.DealerSites.filter((d: any) => d.LocationType == 'Branch' || d.LocationType == 'Principal').map((d: any) => {
        return {label: d.Suburb, value: d.Suburb};
      }).sort();
      const b2 = [ ...branches, ...b];
      setBranches(b2);
      dispatch({type: dealerActionTypes.SET_DEALER, payload: {
        privacyPolicy: traffic.result.PrivacyPolicy, 
        phone, 
        address, 
        website, 
        terms,
        openingHours
      }});
      handleDealerLoaded(traffic.result);
    }
    else {
      const btns: Array<IErrorButton> = [
        {
          title: 'Try again', 
          classes: 'button-solid', 
          callback: () => getDealer(), 
          clearErrorOnClick: true
        }, 
        {
          title: 'Back to registration', 
          classes: 'button-outline', 
          callback: () => { location.pathname = Routes.Specs }, 
          clearErrorOnClick: false
        }
      ]
      const err: IError = { 
        icon: require('../assets/images/exclamation.svg'),
        title: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.', 
        buttons: btns
      };
      dispatch({ type: errorActionTypes.SET_ERROR, payload: err });
    }
  };
  const submitLead = async (data: FormData) => {
    const lead:ILead = {
      instantOfferAppVersion: version,
      dealerID: dealerId,
      stockDealerID: stockDealerId,
      locationName: locationName,
      firstName: data.firstName,
      lastName: data.lastName,
      mobile: data.mobile,
      email: data.email,
      offerDate,
      rego: rego,
      state: auststate,
      kms: parseInt(kms),
      vin: vin,
      vehicleValued: {
        year, 
        make,
        family,
        badge,
        badge2nd,
        vehicleSummary,
        vehicleSpec,
        vehicleImage,
        redbookCode,
        chosenVehicle: {
          redbookcode: redbookCode, // case difference
          rbid,
          makecode,
          familycode,
          vehicletype,
          year,
          month,
          sequenceno,
          description,
          newvehicleflag,
          importflag,
          limitededition,
          series,
          badge,
          badge2nd,
          bodystyle,
          drive,
          geartype,
          gearlocation,
          gearnum,
          doornum,
          enginesize,
          enginedesc,
          cylinders,
          fueltype,
          induction,
          cam,
          enginetype,
          fuelcapacity,
          fueldelivery,
          methoddelivery,
          gvm,
          wheelbase,
          height,
          length,
          width,
          kerbweight,
          taremass,
          power,
          powerrpmto,
          torque,
          torquerpmfrom,
          torquerpmto,
          seatcapacity,
          avgkm,
          gdkm,
          newprice,
          make,
          family,
          isBestMatch,
          imageUrl: vehicleImage, 
          matchDebug
        }
      },
      conditions,
      redbookCode,
      valuation,
      answers,
    
      nextPurchase: interestedNext,
      offerAccepted: false,
      dealerBranch: branches.length > 1 ? data.dealerBranch || '' : '', 
      // valuationResult: valuationResult2, 
      colour
    };
    if (!lead.vehicleValued || !Object.keys(lead.vehicleValued).length) delete lead.vehicleValued;
    if (!lead.conditions || !lead.conditions.length) delete lead.conditions;
    if (!lead.answers || !lead.answers.length) delete lead.answers;
    if (!lead.valuationResult || !Object.keys(lead.valuationResult).length) delete lead.valuationResult;

    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
    const result = await postVehicleLead(lead);
    if (!result.errormessage && result.result && result.result.Success){
      dispatch({ type: appActionTypes.SET_APP, payload: { offerId: result.result.InstantOfferID } });
    }
    else {
      const btns: Array<IErrorButton> = [
        {
          title: 'Try again', 
          classes: 'button-solid', 
          callback: () => submitLead(data), 
          clearErrorOnClick: true
        }, 
        {
          title: 'Back to registration', 
          classes: 'button-outline', 
          callback: () => { location.pathname = baseName + Routes.Specs }, 
          clearErrorOnClick: false
        }
      ]
      const err: IError = { 
        icon: require('../assets/images/exclamation.svg'),
        title: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.', 
        buttons: btns
      };
      dispatch({ type: errorActionTypes.SET_ERROR, payload: err });
    }
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });
  };
  const onSubmit = async (data: FormData) => {
    if (!isSubmitDisabled){
      dispatch({ type: actionTypes.SET_CUSTOMER, payload: data });
      dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
      await submitLead(data);

      dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });

      handleContactSubmit();
    }
  }
  const handleFieldFocus = (name: string) => {
    handleAnalyticEvent({
      type: 'focus', 
      field: name
    })
  };
  const handleButtonClick = (name: string) => {
    handleAnalyticEvent({
      type: AnalyticType.Click, 
      element: AnalyticElement.Button,
      name
    });
  };
  const handleEmailBlur = async (e: any) => {
    if (lastEmail == e.target.value) return;
    setLastEmail(e.target.value);
    setIsEmailValidated(false);
    if (e.target.value){
      setIsEmailLoading(true);
      const r = await validateEmail(e.target.value);
      setIsEmailValidated(r);
      setIsEmailLoading(false);
      if (!r){
        setError('email', {
          type: "manual", 
          message: "This email is not valid."
        });
      }
      else {
        clearErrors('email');
      }
    }
  }
  const handlePhoneBlur = async (e: any) => {
    if (lastPhone == e.target.value) return;
    setLastPhone(e.target.value);
    setIsPhoneValidated(false);
    if (e.target.value){
      setIsPhoneLoading(true);
      const r = await validatePhone(e.target.value);
      setIsPhoneValidated(r);
      setIsPhoneLoading(false);
      if (!r){
        setError('mobile', {
          type: "manual", 
          message: "Your mobile number is incorrect."
        });
      }
      else {
        clearErrors('mobile');
      }
    }
  }
  useEffect(() => {
    if (dealerId && !isInit){
      setIsInit(true);
      getDealer();
    }
  });

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled}>
          <Controller control={control}
            name="firstName"
            rules={{ required: 'First name is required' }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (text: any | null) => {
                onChange(text);
              };
              return <FieldText 
                defaultValue={firstName}
                name={name} 
                inputRef={ref}
                label="First name" 
                error={errors.firstName} 
                onChange={handleFieldChange}
              />
            }} 
          />
          <Controller control={control}
            name="lastName"
            rules={{ required: 'Last name is required' }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (text: any | null) => {
                onChange(text);
              };
              return <FieldText 
                defaultValue={lastName}
                name={name} 
                inputRef={ref}
                label="Last name" 
                error={errors.lastName} 
                onChange={handleFieldChange}
              />
            }} 
          />
          <Controller control={control}
            name="email"
            rules={{ 
              required: 'Email is required', 
              pattern: { 
                value: /^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/, 
                message: 'Your email is incorrect'
              } 
            }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (text: any | null) => {
                onChange(text);
              };
              return <FieldText 
                defaultValue={email}
                name={name} 
                inputRef={ref}
                label="Email" 
                error={errors.email} 
                onChange={handleFieldChange}
                onBlur={handleEmailBlur}
                isLoading={isEmailLoading}
              />
            }} 
          />
          <Controller control={control}
            name="mobile"
            rules={{ required: 'Mobile is required', pattern: { value: /^04[0-9]{8}$/, message: 'Your mobile number is incorrect'} }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (text: any | null) => {
                onChange(text);
              };
              return <FieldText 
                defaultValue={mobile}
                name={name}
                inputRef={ref}
                label="Mobile"
                error={errors.mobile}
                onChange={handleFieldChange}
                onBlur={handlePhoneBlur}
                isLoading={isPhoneLoading}
              />
            }} 
          />
          {branches.length > 1 ? <Controller control={control}
            name="dealerBranch"
            rules={{ required: 'Preferred dealership is required' }}  
            render={({ field: { onChange, name, ref } }) => {
              const handleSelectChange = (selectedOption: any | null) => {
                onChange(selectedOption?.value);
              };
              return <FieldSelect 
                name={name}
                inputRef={ref}
                defaultValue={branches[0]}
                options={branches}
                error={errors.dealerBranch}
                onFocus={() => handleFieldFocus('Preferred dealership')}
                onChange={handleSelectChange}
              />
            }}
          /> : ''}
          <Controller control={control}
            name="terms"
            rules={{ required: 'You must agree with the terms of use and privacy policy.' }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (text: any | null) => {
                onChange(text);
              };
              return <FieldCheckbox 
                defaultValue={terms}
                name={name} 
                inputRef={ref}
                label={`I agree with the website <a target="_blank" href="${termsUrl}">Terms of Use</a> and understand that my information will be handled by the Dealer and One Toyota under the Dealer <a target="_blank" href="${privacyPolicy || 'https://www.toyota.com.au/privacy-policy'}">Privacy Policy</a>`} 
                error={errors.terms} 
                onChange={handleFieldChange}
              />
            }} 
          />
         
          {/* <ErrorSummary errors={errors} /> */}
          <div className="i-button-group">
              <button type="submit" 
              disabled={isSubmitDisabled}
              className="button-outline" 
              onClick={() => handleButtonClick(`${version == EAppVersion.a ? 'Show' : 'Email'} valuation`)}
            >{version == EAppVersion.a ? 'Show' : 'Email'} Valuation</button>
          </div>
        </fieldset>
      </form>
    </Fragment>
  )
}

export default Contact;